import {IconType} from 'react-icons'

import {BsBuilding, BsInbox} from 'react-icons/bs'

import {
    BsBookHalf,
    BsCheckLg,
    BsFileEarmarkBarGraphFill,
    BsFillCalendarFill,
    BsFillChatLeftTextFill,
    BsFillFileImageFill,
    BsFillInfoCircleFill,
    BsFillPatchCheckFill,
    BsFillPeopleFill,
    BsFillPersonVcardFill,
    BsFillPostcardFill,
    BsFillQuestionCircleFill,
    BsFire,
    BsGearFill,
    BsMapFill,
    BsPencilFill,
    BsPeopleFill,
    BsPlus,
    BsTrainFrontFill,
    BsWebcamFill,
    BsXLg,
} from 'react-icons/bs'
import {
    FaArrowDown,
    FaArrowUp,
    FaChevronLeft,
    FaChevronRight,
    FaCross,
    FaMinusCircle,
    FaPeopleArrows,
    FaRegCopy,
    FaSearch,
    FaTheaterMasks,
    FaUserAlt
} from 'react-icons/fa'
import {TbBookOff, TbCirclePercentage, TbLocationFilled, TbTargetArrow} from 'react-icons/tb'
import {FiLogIn} from 'react-icons/fi'
import {GrCircleQuestion} from 'react-icons/gr'
import {HiDotsCircleHorizontal, HiOutlineUserAdd, HiPencilAlt} from 'react-icons/hi'
import {ImLibrary, ImSpinner11} from 'react-icons/im'
import {BiExit, BiNetworkChart, BiSearchAlt2, BiTime, BiTransfer} from 'react-icons/bi'
import {
    AiFillCheckCircle,
    AiFillDislike,
    AiFillExperiment,
    AiFillLike,
    AiFillNotification,
    AiFillPicture,
    AiFillStar,
    AiOutlineAppstore,
    AiOutlineStar
} from 'react-icons/ai'
import {RiArrowGoBackFill, RiComputerFill, RiFilePaperLine, RiFunctionFill, RiLockPasswordFill} from 'react-icons/ri'
import {
    MdBedtime,
    MdBrowserNotSupported,
    MdCancel,
    MdDarkMode,
    MdEmail,
    MdFeedback,
    MdHistoryEdu,
    MdIosShare,
    MdLanguage,
    MdLightMode,
    MdOutlineEmojiPeople,
    MdPrivacyTip,
    MdQuiz, MdRecommend,
    MdWbSunny
} from 'react-icons/md'
import {GiEvilBook, GiThink} from 'react-icons/gi'
import {IoReloadCircle} from 'react-icons/io5'
import {PiPencilBold} from 'react-icons/pi'
import {FaCirclePlus} from 'react-icons/fa6'

const booksitoutIcon: { [key: string]: IconType } = {
	login: FiLogIn,
	join: HiOutlineUserAdd,
	question: GrCircleQuestion,
	user: FaUserAlt,

    recommend: MdRecommend,

	// settings
	settings: BsGearFill,
	paid: BsFillPatchCheckFill,
	lightMode: MdLightMode,
	darkMode: MdDarkMode,

	// pwa
	pwa: AiOutlineAppstore,
	notSupported: MdBrowserNotSupported,
	info: BsFillInfoCircleFill,

	location: TbLocationFilled,
	map: BsMapFill,

	search: FaSearch,
	topnavSearch: BiSearchAlt2,

	book: BsBookHalf,
	title: BsPencilFill,
	author: BsFillPeopleFill,
	description: BsFillChatLeftTextFill,
	publishYear: BsFillCalendarFill,
	page: RiFilePaperLine,
	giveUp: BiExit,
	unGiveUp: ImSpinner11,
	review: PiPencilBold,

	// Statistics
	statistics: BsFileEarmarkBarGraphFill,
	star: AiOutlineStar,
	starFill: AiFillStar,
	goal: TbTargetArrow,
	language: MdLanguage,
	category: FaTheaterMasks,
	consecutive: BsFire,
	currentReading: MdOutlineEmojiPeople,

	categoryOthers: HiDotsCircleHorizontal,
	categoryPhilosophy: GiThink,
	categoryReligion: FaCross,
	categoryNaturalScience: AiFillExperiment,
	categoryLanguage: MdLanguage,
	categoryLiterature: GiEvilBook,
	categoryHistory: MdHistoryEdu,

	categoryArt: AiFillPicture,
	categoryTechnology: RiComputerFill,
	categorySocialScience: BiNetworkChart,

	// Community
	community: BsPeopleFill,
	popular: BsFire,
	post: BsFillPostcardFill,
	quiz: MdQuiz,
	image: BsFillFileImageFill,
	like: AiFillLike,
	dislike: AiFillDislike,

	check: AiFillCheckCircle,
	bought: BsCheckLg,
	xmark: MdCancel,
	shouldBuy: BsXLg,
	plus: BsPlus,

	// gathering
	gathering: FaPeopleArrows,
	subway: BsTrainFrontFill,
	online: BsWebcamFill,
	others: BsFillQuestionCircleFill,

	// tips
	time: BiTime,

	// library
	library: ImLibrary,
	membership: BsFillPersonVcardFill,
	copy: FaRegCopy,
	share: MdIosShare,
	percent: TbCirclePercentage,
	timeOpen: MdWbSunny,
	timeClosed: MdBedtime,
    password: RiLockPasswordFill,

	// admin
	faq: BsFillQuestionCircleFill,
	suggestion: MdFeedback,

	convert: BiTransfer,

	feature: RiFunctionFill,

	privacy: MdPrivacyTip,

	notification: AiFillNotification,
	email: MdEmail,

	reload: IoReloadCircle,

	bookXmark: TbBookOff,
	noBook: TbBookOff,

	add: FaCirclePlus,
	delete: FaMinusCircle,
	edit: HiPencilAlt,
	back: RiArrowGoBackFill,

	ArrowDown: FaArrowDown,
	ArrowUp: FaArrowUp,
	ArrowLeft: FaChevronLeft,
	ArrowRight: FaChevronRight,

	noContent: BsInbox,
	building: BsBuilding,
}

export default booksitoutIcon
